// avatar-utils.ts
export const CDN_BASE = 'https://dbappstorage.ams3.digitaloceanspaces.com/';

export function avatarUrl(row: any): string | undefined {
  const direct = row?.avatarUrl;
  const path   = row?.avatarPath;
  if (direct && /^https?:\/\//.test(direct)) return direct;
  if (path && typeof path === 'string') {
    const clean = path.startsWith('/') ? path.slice(1) : path;
    // opzionale: bust cache se hai un updatedAt
    const v = row?.updatedAt ? `?v=${new Date(row.updatedAt).getTime()}` : '';
    return `${CDN_BASE}${clean}${v}`;
  }
  return undefined;
}

export function initials(name?: string, lastname?: string) {
  const a = (name || '').trim();
  const b = (lastname || '').trim();
  const first = a ? a[0].toUpperCase() : '';
  const second = b ? b[0].toUpperCase() : '';
  return (first + second) || (a || b).slice(0, 1).toUpperCase();
}

// opzionale: un colore di background deterministico per il fallback
export function colorFromString(s: string) {
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = s.charCodeAt(i) + ((hash << 5) - hash);
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue} 65% 55%)`;
}
